export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/vader-profile-4994b5cfbc600e1d9c76a2e73d8fdc6a.png";